import URLS from '../../config/urls'
import ajax from './ajax'
let base = URLS.API_URL

// 会议室相关
export const getMeetingList = params => { return ajax.get(`${base}/meeting/v1/list/` + params).then(res => res) }
export const getMeetingDetail = params => { return ajax.get(`${base}/meeting/v1/detail/` + params).then(res => res) }
export const requestCreateMeeting = params => { return ajax.post(`${base}/meeting/v1/list/`, params).then(res => res) }
export const requestMeetingOrderCancel = params => { return ajax.post(`${base}/meeting/v1/cancellation/`, params).then(res => res) }
export const getMeetingOrderInfo = params => { return ajax.get(`${base}/meeting/v1/orderinfo/` + params).then(res => res) }
export const requestMeetingOrderInfoUpdate = params => { return ajax.post(`${base}/meeting/v1/update/`, params).then(res => res) }

// 监控相关
export const getMonitorList = params => { return ajax.get(`${base}/monitor/v1/list/alarmConfig/` + params).then(res => res) } //获取报警配置
export const handleMonitorList = params => { return ajax.post(`${base}/monitor/v1/list/alarmConfig/`, params).then(res => res) } //编辑报警配置
export  const getGroupList = params => { return ajax.get(`${base}/monitor/v1/list/groupConfig/` + params).then(res => res) }
export const handleGroupList = params => { return ajax.post(`${base}/monitor/v1/list/groupConfig/`, params).then(res => res) } //编辑报警配置
export const getSpecialConfig = params => { return ajax.get(`${base}/monitor/v1/list/sepcialConfig/` + params).then(res => res) } //获取特殊策略配置
export const getMaintianConfigList = params => {return ajax.get(`${base}/monitor/v1/list/maintianConfig/` + params).then(res => res)} //获取maintian配置
export const handMaintianConfigList = params => {return ajax.post(`${base}/monitor/v1/list/maintianConfig/`,params).then(res => res)} //编辑maintian配置


// // 用户相关
export const requestLogin = params => { return ajax.post(`${base}/users/v1/user/login/`, params).then(res => res) }
//获取所有的用户
export const getAllUserInfo = params => { return ajax.get(`${base}/users/v1/user/getAllUser/`, params).then(res => res)}
//添加代理人
export const requestAddAgentUser = params => { return ajax.post(`${base}/users/v1/add_agent/`, params).then(res => res) }
//用户密码修改
export const userPasswdModify = params => { return ajax.post(`${base}/users/v1/user/userPasswdModify/`,params).then(res => res)}
//获取用户信息
export const getUserInfoRequest = params => { return ajax.get(`${base}/users/v1/user/userInfo/` + params).then(res => res) }
// 获取工单模板
export const getOrderTemplateRequest = params => { return ajax.get(`${base}/workorder/ordertpl/list/` + params).then(res => res) } // uuid

// 获取指定模板字段配置
// export const getOrderFieldConfRequest = params => { return ajax.get(`${base}/api_workflow/ordertpl/conf/` + params).then(res => res) } // uuid
export const getOrderFieldConfRequest = params => { return ajax.get(`${base}/workorder/ordertpl/conf/` + params).then(res => res) } // uuid

// 获取指定模板审批流程和工单配置信息
// export const getOrderFlowStepRequest = params => { return ajax.get(`${base}/api_workflow/ordertpl/flow_step/` + params).then(res => res) } // uuid
export const getOrderFlowStepRequest = params => { return ajax.get(`${base}/workorder/ordertpl/flow_step/` + params).then(res => res) } // uuid

// 创建工单
// export const requestOrderCreate = params => { return ajax.post(`${base}/api_workflow/workorder/create/`, params).then(res => res) }
export const requestOrderCreate = params => { return ajax.post(`${base}/workorder/workorder/create/`, params).then(res => res) }

// 获取申请的工列表
// export const getSubmitOrderRequest = params => { return ajax.get(`${base}/api_workflow/workorder/list/` + params).then(res => res) } // uuid
export const getSubmitOrderRequest = params => { return ajax.get(`${base}/workorder/workorder/list/` + params).then(res => res) } // uuid

//获取suborder自动工单执行日志
export const getSubOrderLogRequest = params => { return ajax.get(`${base}/workorder/suborder/callbackLog/` + params).then(res => res) }
// 获取待我审批工单
// export const getApproveSubOrderRequest = params => { return ajax.get(`${base}/api_workflow/suborder/list/` + params).then(res => res) } // uuid
export const getApproveSubOrderRequest = params => { return ajax.get(`${base}/workorder/suborder/list/` + params).then(res => res) } // uuid

// 获取SubOrder中用户提交工单描述信息
export const getSubOrderDescRequest = params => { return ajax.get(`${base}/workorder/suborder/desc/` + params).then(res => res) } // uuid

// 获取SubOrder审批步骤
export const getSubOrderStepRequest = params => { return ajax.get(`${base}/workorder/suborder/step/` + params).then(res => res) } // uuid

// 审批工单
export const requestSuborderApprove = params => { return ajax.post(`${base}/workorder/suborder/approve/`, params).then(res => res) }






// 用户撤回自己的工单
export const requestWorkorderWithdraw = params => { return ajax.post(`${base}/api_workflow/workorder/withdraw`, params).then(res => res) }



// 自动化工单重试/跳过
export const requestRetrySuborderApprove = params => { return ajax.post(`${base}/api_workflow/suborder/retry_approve/`, params).then(res => res) }


// 修改工单
export const requestWorkOrderModify = params => { return ajax.post(`${base}/api_workflow/workorder/modify/`, params).then(res => res) }

// 催单
export const requestRemindSuborderApprove = params => { return ajax.post(`${base}/api_workflow/suborder/remind/`, params).then(res => res) }

// 获取用户信息
// export const getUserInfoRequest = params => { return ajax.get(`${base}/api_workflow/userinfo/` + params).then(res => res) } // uuid

// 添加代理人
// export const requestAddAgentUser = params => { return ajax.post(`${base}/api_workflow/add_agent/`, params).then(res => res) }

// 获取工单所有工单模板
export const getFlowConfRequest = params => { return ajax.get(`${base}/api_workordermanager/flowconf/` + params).then(res => res) } // uuid

// 修改工单显示状态
export const operateFlowconfShowRequest = params => { return ajax.get(`${base}/api_workordermanager/flowconf/manage/` + params).then(res => res) } // uuid

// 新建工单
export const operateCreateFlowconfRequest = params => { return ajax.post(`${base}/api_workordermanager/flowconf/manage/`, params).then(res => res) }

// 获取mis部门树
export const getMisDeptTreeRequest = params => { return ajax.get(`${base}/api_workordermanager/mis/depttree/` + params).then(res => res) } // uuid

// 获取mis对应部门人员
export const getMisDeptPersonsRequest = params => { return ajax.get(`${base}/api_workordermanager/flowconf/deptperson/` + params).then(res => res) } // uuid

// 获取人员pool名
export const getPersonPoolsRequest = params => { return ajax.get(`${base}/api_workordermanager/person/pools/` + params).then(res => res) } // uuid

// 获取FlowConf工单模板审批流
export const getFlowRoleConfRequest = params => { return ajax.get(`${base}/api_workordermanager/flowroleconf/` + params).then(res => res) } // uuid

// del NewFlowUserRoleActionConf
// export const requestFlowRoleConf = params => { return ajax.post(`${base}/api_workordermanager/flowroleconf/` + params).then(res => res) } // uuid
export const requestFlowRoleConf = params => { return ajax.post(`${base}/api_workordermanager/flowroleconf/`, params).then(res => res) }

// 选中工单模板分类列表
export const getFlowConfClassingRequest = params => { return ajax.get(`${base}/api_workordermanager/flowconf/classing/` + params).then(res => res) } // uuid

// 提交工单分类
export const requestFlowConfClassing = params => { return ajax.post(`${base}/api_workordermanager/flowconf/classing/`, params).then(res => res) }

// 获取自动化工原有配置
export const getAutoActionConfRequest = params => { return ajax.get(`${base}/api_workordermanager/flowconf/autoaction/` + params).then(res => res) } // uuid

// 提交修改后的自动化工单
export const requestModifyFlowRoleConf = params => { return ajax.post(`${base}/api_workordermanager/flowconf/autoaction/`, params).then(res => res) }




// WEBPACK FOOTER //
// ./src/api/api.js